module.exports = __webpack_public_path__ + "img/user.e3140a30.jpg";